import {
  ScrollArea
} from "./chunk-CIPMRU3J.js";
import {
  cn
} from "./chunk-S2JEC2ZU.js";

// src/mdx/pre.tsx
import { CheckIcon, CopyIcon } from "lucide-react";
import { forwardRef, useCallback, useEffect, useRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Pre = forwardRef(
  ({ title, allowCopy = true, pre, className, ...props }, ref) => {
    const preRef = useRef(null);
    const onCopy = useCallback(() => {
      if (!preRef.current?.textContent)
        return;
      void navigator.clipboard.writeText(preRef.current.textContent);
    }, []);
    return /* @__PURE__ */ jsxs(
      "figure",
      {
        ref,
        className: cn(
          "not-prose group relative my-6 overflow-hidden rounded-lg border bg-secondary/50 text-sm",
          className
        ),
        ...props,
        children: [
          title ? /* @__PURE__ */ jsxs("div", { className: "flex flex-row items-center border-b bg-muted py-1.5 pl-4 pr-2 text-muted-foreground", children: [
            /* @__PURE__ */ jsx("figcaption", { className: "flex-1", children: title }),
            allowCopy ? /* @__PURE__ */ jsx(CopyButton, { onCopy }) : null
          ] }) : allowCopy && /* @__PURE__ */ jsx(
            CopyButton,
            {
              className: "absolute right-2 top-2 z-[2]",
              onCopy
            }
          ),
          /* @__PURE__ */ jsx(ScrollArea, { children: /* @__PURE__ */ jsx(
            "pre",
            {
              ref: preRef,
              ...pre,
              className: cn("nd-codeblock py-4", pre?.className),
              children: props.children
            }
          ) })
        ]
      }
    );
  }
);
Pre.displayName = "CodeBlock";
function CopyButton({
  className,
  onCopy,
  ...props
}) {
  const [checked, setChecked] = useState(false);
  const timeoutRef = useRef();
  const onClick = () => {
    if (timeoutRef.current)
      window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(() => {
      setChecked(false);
    }, 1500);
    onCopy();
    setChecked(true);
  };
  useEffect(() => {
    return () => {
      if (timeoutRef.current)
        window.clearTimeout(timeoutRef.current);
    };
  }, []);
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      className: cn(
        "inline-flex rounded-md bg-muted p-2 text-secondary-foreground transition-opacity group-hover:opacity-100",
        !checked && "opacity-0",
        className
      ),
      "aria-label": "Copy Text",
      onClick,
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          CheckIcon,
          {
            className: cn(
              "h-3.5 w-3.5 transition-transform",
              !checked && "scale-0"
            )
          }
        ),
        /* @__PURE__ */ jsx(
          CopyIcon,
          {
            className: cn(
              "absolute h-3.5 w-3.5 transition-transform",
              checked && "scale-0"
            )
          }
        )
      ]
    }
  );
}

export {
  Pre
};
